import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const SideMenuIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 20 18"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={1}
    stroke="none"
    fill="currentColor"
  >
    <path
      d="M18.25.75H1.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5001 1.5001 0 0 0 1.5 1.5h16.5a1.5001 1.5001 0 0 0 1.5-1.5V2.25a1.5 1.5 0 0 0-1.5-1.5Zm0 1.5V6H1.75V2.25h16.5ZM1.75 7.5H7v8.25H1.75V7.5Zm16.5 8.25H8.5V7.5h9.75v8.25Z"
      stroke="none"
      fill="currentColor"
    />
  </SvgIcon>
);

export default SideMenuIcon;
